<template>
    <div id="app">
       <router-view/>
    </div>
</template>

<script setup>
</script>

<style>
:root {
  --color-primary: #409EFF;
  --color-primary-light: #ECF5FF;
  --color-primary-dark: #337ECC;
  --color-sidebar-bg: #1D1E2C;
  --color-sidebar-text: #BFCAE0;
  --color-sidebar-active: #FFFFFF;
  --color-sidebar-active-bg: #409EFF;
  --color-header-bg: #FFFFFF;
  --color-body-bg: #F2F3F5;
  --color-card-bg: #FFFFFF;
  --color-text: #303133;
  --color-text-secondary: #909399;
  --header-height: 56px;
  --sidebar-width: 220px;
}

html, body {
  margin: 0;
  height: 100%;
  overflow-x: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: var(--color-text);
  background-color: var(--color-body-bg);
}

#app {
  min-height: 100vh;
}

@media (max-width: 768px) {
  * {
    box-sizing: border-box;
  }
  body {
    font-size: 14px;
  }
}
</style>
